import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import {
  NotificationActionResponse,
  NotificationsListResponse,
  NotificationsParams,
} from '../models/notifications.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private http = inject(HttpClient);

  getNotifications(params: NotificationsParams): Observable<NotificationsListResponse> {
    const httpParams = new HttpParams().set('page', params.page).set('per_page', params.per_page);

    return this.http.get<NotificationsListResponse>(`${environment.endpoint}/notifications`, {
      params: httpParams,
    });
  }

  markAsRead(id: string): Observable<NotificationActionResponse> {
    return this.http.post<NotificationActionResponse>(
      `${environment.endpoint}/notifications/mark-as-read/${id}`,
      {}
    );
  }

  markAllAsRead(): Observable<NotificationActionResponse> {
    return this.http.post<NotificationActionResponse>(
      `${environment.endpoint}/notifications/mark-all-as-read`,
      {}
    );
  }

  markAsViewed(): Observable<NotificationActionResponse> {
    return this.http.post<NotificationActionResponse>(
      `${environment.endpoint}/notifications/mark-viewed`,
      {}
    );
  }
}
